import { protrakApiClient } from '../utils/protrakApiClient';
import { useApi } from '../utils/useApi';
import { useProtrakApi } from '../utils/useProtrakApi';

const homeBaseURL = 'home';
const settingsURL = `${homeBaseURL}/settings`;
const homeLayoutURL = `${homeBaseURL}/layout`;
const userMeUrl = '/users/me';

export const HOME_LAYOUT_STD_WIDGET_TYPE_CONTRACT = {
  MyTasks: 'MyTasks',
  MyMessages: 'MyMessages',
  ManageTasks: 'ManageTasks',
  MyRecentlyUpdatedItems: 'MyRecentlyUpdatedItems'
};

export function useTenantSettings() {
  const { state, run } = useApi({
    requestConfig: tenantSettingsPromiseFn
  });
  return [state, run];
}

const tenantSettingsPromiseFn = () => {
  return { endpoint: settingsURL };
};

export function useContextUserDetails() {
  const { state, run } = useApi({
    requestConfig: contextUserDetailsPromiseFn
  });
  return [state, run];
}

const contextUserDetailsPromiseFn = () => {
  return { endpoint: userMeUrl };
};

export function useAllSettings() {
  const { state, run } = useProtrakApi({ promiseFn: allSettingsPromiseFn });
  return [state, run];
}

const allSettingsPromiseFn = async ({ authContext }) => {
  try {
    const userDetailsResponse = await protrakApiClient(
      userMeUrl,
      {},
      authContext
    );
    if (userDetailsResponse) {
    }
    const [settingsResponse] = await Promise.all([
      protrakApiClient(settingsURL, {}, authContext)
    ]);

    return {
      data: {
        settings: settingsResponse.data,
        userData: userDetailsResponse.data
      }
    };
  } catch (error) {
    throw error;
  }
};
export const useHomeLayoutConfig = () => {
  const { state, run } = useApi(
    { requestConfig: fetchHomeLayout },
    { cacheKey: homeLayoutURL }
  );
  return { state, run };
};

const fetchHomeLayout = () => {
  const cacheData = JSON.parse(window.localStorage.getItem(homeLayoutURL));
  return {
    endpoint: homeLayoutURL,
    config: {
      modified: cacheData ? cacheData.modified : null
    }
  };
};
